import { Box, Typography } from "@mui/material";
import { membershipNotes } from "../constants";

export const MembershipNoteGrid = () => (
  <Box
    sx={{
      mt: 2,
      display: "grid",
      gridTemplateColumns: { xs: "1fr", sm: "repeat(3, 1fr)" },
      border: "1px solid",
      borderColor: "divider",
    }}
  >
    {membershipNotes.map(([number, title, copy], index) => (
      <Box
        key={title}
        sx={{
          p: 2.25,
          minHeight: 160,
          borderLeft: { sm: index === 0 ? "none" : "1px solid" },
          borderTop: { xs: index === 0 ? "none" : "1px solid", sm: "none" },
          borderColor: "divider",
          bgcolor: index === 1 ? "background.paper" : "background.default",
        }}
      >
        <Typography variant="caption" sx={{ color: "secondary.main", fontWeight: 800, letterSpacing: "0.1em" }}>
          {number}
        </Typography>
        <Typography sx={{ mt: 1.5, fontWeight: 800, fontSize: "1rem", letterSpacing: "-0.02em" }}>{title}</Typography>
        <Typography sx={{ mt: 0.75, color: "text.secondary", fontSize: "0.74rem", lineHeight: 1.55 }}>
          {copy}
        </Typography>
      </Box>
    ))}
  </Box>
);
